const went = {
  namespaced: true,
  state: {
    went: [1, 20, 25, 30]
  },
  getters: {
    getWent: (state) => state.went
  },
  mutations: {
    setWent (state, went) {
      state.went = went
    }
  },
  actions: {
    setWent ({ commit }, went) {
      commit('setWent', went)
    }
  }
}

export default went



// WEBPACK FOOTER //
// ./src/vuex/went.js